



















import { Component, Vue, Prop } from 'vue-property-decorator';
import Upload from '@/components/Upload.vue';
import { getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';

@Component({
  components: {
    Upload,
  },
})
export default class FileUploadList extends Vue {
  @Prop() public fileList!: Array<any>;
  public studentId: number = 0;
  public config: any = config;

  public created(): any {
    this.studentId = this.$route.query.studentId ? Number(this.$route.query.studentId) : 0;
  }

    public get school() {
    return getSchoolInfo().shortName;
  }

  public get uploadList() {
    return this.config[this.school].upload;
  }

  public get locale(): string {
    return this.$i18n.locale;
  }
}
